import {
  FaAward,
  FaClock,
  FaUsers,
  FaShieldAlt,
  FaHandshake,
  FaChartLine,
} from "react-icons/fa";

const ServiceBenefits = ({ service }) => {
  const icons = [
    FaAward,
    FaClock,
    FaUsers,
    FaShieldAlt,
    FaHandshake,
    FaChartLine,
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container-custom">

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Benefits
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Why This Service Matters
          </h2>

        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {service.benefits.map((benefit, index) => {
            const Icon = icons[index % icons.length];

            return (
              <div
                key={index}
                className="bg-slate-50 rounded-3xl p-8 text-center"
              >
                <div className="w-20 h-20 mx-auto rounded-2xl bg-[#082B57] text-white flex items-center justify-center text-3xl">
                  <Icon />
                </div>

                <h3 className="text-xl font-bold text-[#082B57] mt-6">
                  {benefit}
                </h3>
              </div>
            );
          })}

        </div>

      </div>
    </section>
  );
};

export default ServiceBenefits;